/**
 * It actually does not matter for us what we call this redirect path
 * but this is set to v3 to remind us that backend is using v3
 */
export const REDIRECT_PATH = '/auth/v3/';
export const REDIRECT_URI = `${process.env.BASE_URL}/-/external/nylas${REDIRECT_PATH}`;
